import { makeStyles } from '@material-ui/core';
import { relative } from 'path';

const welcomePageStyles = makeStyles((theme) => {
  const mobileBreakpoint = theme.breakpoints.down('sm');
  const lessThan1440Breakpoint = theme.breakpoints.down(1440); 
  const maxImgHeight =  'calc(48vh - 50px)';
  return (
    {
      welcomePageWrapper: {
        minHeight: 'calc(100vh - 208px)',
        display: 'flex',
        alignItems: 'center',
        marginBottom: 0,
        paddingLeft: '48px',
        paddingRight: '48px',
        [mobileBreakpoint]: {
          paddingLeft: '24px',
          paddingRight: '24px'
        }
      },
      secondaryContent: {
        fontFamily: 'Roboto',
        fontSize: '1.5rem',
        fontWeight: 500,
        lineHeight: '2.125rem',
        color: '212121',
        marginBottom: '2rem',
        [mobileBreakpoint]: {
          fontSize: '1.25rem',
          marginBottom: '24px'
        }
      },
      whatToExpect: {
        fontFamily: 'Roboto',
        fontSize: '1rem',
        fontWeight: 500,
        lineHeight: '1.375rem',
        [mobileBreakpoint]: {
          margin: 'auto',
          paddingBottom: '12px'
        }
      },
      bannerTitle: {
        fontFamily: "Roboto",
        fontSize: "2.625rem",
        lineHeight: "3.625rem",
        letterSpacing: "0em",
        textAlign: "left",
        marginBottom: '16px',
        [mobileBreakpoint]: {
          fontSize: '2rem',
        }
      },
      bulletPoints: {
        fontFamily: "Roboto",
        fontSize: "1rem",
        lineHeight: "1.75rem",
        fontWeight: 400,
        width: '100%',
        marginLeft: 0,
        paddingLeft: '1.563rem',
        [mobileBreakpoint]: {
          width: "100%",
          height: 'auto',
          paddingBottom: '1rem'
        }
      },
      bePreparedToContents: {
        paddingTop: '24px',
        [mobileBreakpoint]: {
          paddingTop: '0px'
        }
      },
      stepCount: {
        marginRight: '16px',
        height: '24px',
        backgroundColor: '#E3E3E3',
        color: "var(--black)",
        borderRadius: '50%',
        flex: '0 0 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      },
      contentHeader: {
        color: 'var(--grey-900, #3A3A3A)',
        fontSize: '16px',
        fontWeight: 500,
        display: 'flex',
        alignItems: 'center'
      },
      documentsRowOne: {
        display: 'flex',
        paddingBottom: '8px',
        [mobileBreakpoint]: {
          flexDirection: 'column',
          gap: '8px'
        }
      },
      documentsRowTwo: {
        display: 'flex',
        [mobileBreakpoint]: {
          flexDirection: 'column',
          gap: '8px'
        }
      },
      documentColumn: {
        width: '162px',
        marginRight: '40px',
        display: 'flex',
        alignItems: 'center',
        fontSize: '14px'
      },
      documentImage: {
        paddingRight: '8px'
      },
      providersLogoContainer: {
        display: 'flex',
        gap: '26px'
      },
      acceptance: {
          display: 'flex',
          alignItems: 'top',
          marginBottom: '1rem',
          width: '72%'
      },
      continueBtn: {
          background: '#007DB8 !important',
          borderRadius: '0.25rem',
          fontWeight: 500,
          fontSize: '0.875rem',
          lineHeight: '1.875rem',
          fontFamily: 'var(--font-family-bold)',
          textTransform: 'capitalize',
          color: 'var(--white) !important',
          marginTop: '1rem',
          width: '100%',
          '&[disabled]': {
            color: 'var(--white) !important',
            backgroundColor: 'var(--disabled) !important'
          }
      },
      flexBox: {
        display: 'flex',
        justifyContent: 'space-around',
        maxWidth: '1204px',
        width: '100%',
        marginLeft: 'auto',
        marginRight: 'auto',
        maxHeight: '100%',
        [lessThan1440Breakpoint]: {
          maxWidth: '1040px'
        },
        [mobileBreakpoint]: {
          display: 'block',
          margin: 'auto',
          paddingRight: '0px',
          paddingTop: '0px',
        }
      },
      betaTag: {
        position: 'absolute',
        right: 0,
        top: 0,
      },
      rightBox: {
        flexDirection: 'column',
        gap: '1.5rem',
        paddingLeft: '25px',
        marginLeft: 'auto',
        alignItems: 'center',
        [mobileBreakpoint]: {
          display: 'block',
          paddingRight: '0px',
        paddingLeft: '0px',
        }
      },
      rightInnerBox: {
        position: 'relative',
        [mobileBreakpoint]: {
          width: '100%',
          height: 'auto'
        }
      },
      leftBox: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: "33.25rem",
        paddingRight: '25px',
        marginRight: 'auto',
        [mobileBreakpoint]: {
          display: 'block',
          marginRight: '0px',
          marginLeft: '0px',
          gap: '0px',
          width: '100%',
          height: 'auto',
          padding: '0px 0px 24px 0px'
        }
      },
      tooltipText: {
        color: '#007DB8',
        cursor: 'pointer'
      },
      toolTipList: {
        paddingLeft: "1em",
      },
      btn_primary: {
        color: 'var(--white)',
        backgroundColor: 'var(--teal-blue)',
        '&:hover': {
          color: 'var(--white)',
          backgroundColor: 'var(--teal-blue)',
        }
      },
      applicationText: {
        [mobileBreakpoint]: {
          fontSize: '1.25rem !important',
        }
      },
      securityInfoTitle:{
        fontFamily: "Roboto",
        fontSize: "14px",
        fontWeight: 500,
        overflowWrap: "break-word",
        color: "#757575",
        lineHeight: "20px",
      },
      securityInfoContent:{
        fontFamily: "Roboto",
        fontSize: "12px",
        overflowWrap: "break-word",
        color: "#757575",
        lineHeight: "16px",
      },
      dialogTitle:{
        "& .MuiDialogTitle-root": {
          paddingTop: "24px"
        }
      },
      emailDialogMainContainer: {
        position: 'relative',
        color: '#212121'
      },
      closeIcon: {
        position: 'absolute',
        top: 0,
        right: 0,
        cursor: 'pointer'
      },
      emailDialogContentContainer: {
        padding: '16px 16px 0px 16px'
      },
      emailDialoglHeading: {
        fontSize: '20px',
        fontWeight: 500,
        paddingBottom: '10px'
      },
      emailDialogContents: {
        display: 'flex',
        flexDirection: 'column',
        gap: '20px'
      },
      closeButton: {
        background: '#007DB8 !important',
        borderRadius: '0.25rem',
        fontWeight: 500,
        fontSize: '0.875rem',
        lineHeight: '1.875rem',
        fontFamily: 'var(--font-family-bold)',
        textTransform: 'capitalize',
        color: 'var(--white) !important',
      },
      lendexSupportLink: {
        cursor: 'pointer'
      },
      trapezoidBg: {
        position: 'relative',
        zIndex: 1,
        "&::before": {
          content: '""',
          background: 'linear-gradient(234deg, #005C82 28.58%, #0B9EDB 99.46%)',
          position: 'absolute',
          top: '0',
          left: '0',
          width: '100%',
          height: '100%',
          clipPath: 'polygon(95% 0, 100% 0, 100% 100%, 37.5% 100%)'
        }
      }
    })
});

export default welcomePageStyles;